import { UniverseCommunity } from './universeTypes';

export interface UniverseRegion { id: string; name: string; communities: UniverseCommunity[]; cardCount: number; accent: string }

// Use public location geography. Unknown geography stays explicitly unassigned.
export function regionForLocation(location: Record<string, any>): { id: string; name: string } {
  const address = location.address;
  const city = String(typeof address === 'object' ? address?.city || '' : '').trim();
  const state = String(typeof address === 'object' ? address?.state || '' : '').trim().toUpperCase();
  const lat = typeof location.latitude === 'number' ? location.latitude : NaN;
  const lng = typeof location.longitude === 'number' ? location.longitude : NaN;
  const label = `${city} ${typeof address === 'string' ? address : ''} ${location.partnerName || ''}`.toLowerCase();
  if ((lat > 41.7 && lat < 43 && lng > -71.8 && lng < -70.5) || /boston/.test(label) || state === 'MA') return { id: 'greater-boston', name: 'Greater Boston' };
  if ((lat > 41.3 && lat < 42.6 && lng > -88.6 && lng < -87.2) || /chicago|kenilworth/.test(label)) return { id: 'chicago', name: 'Chicago' };
  if (city) return { id: `${city}-${state}`.toLowerCase().replace(/[^a-z0-9]+/g, '-'), name: city };
  if (state) return { id: state.toLowerCase(), name: state };
  return { id: 'elsewhere', name: 'Beyond the map' };
}

export function groupRegions(communities: UniverseCommunity[]): UniverseRegion[] {
  const regions = new Map<string, UniverseRegion>();
  communities.forEach(community => {
    const id = community.regionId || 'elsewhere';
    const region = regions.get(id) || { id, name: community.regionName || 'Beyond the map', communities: [], cardCount: 0, accent: id === 'greater-boston' ? '#83dfd2' : id === 'chicago' ? '#a9b5ff' : '#e6c49a' };
    region.communities.push(community);
    region.cardCount += community.cardCount;
    regions.set(id, region);
  });
  return Array.from(regions.values()).sort((a, b) => a.id.localeCompare(b.id));
}
